export const CANONICAL_TEMPLATE_KEYS = {
	MEETING_NOTES:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
	PROJECT_PLAN:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
	EOW_STATUS_REPORT:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
	DECISIONS: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
	REQUIREMENTS_RACI:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
	RETROSPECTIVES:
		'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
	BUSINESS_STATUS_UPDATE:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
	ONE_ON_ONE_MEETING:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
	RECURRING_MEETING_MINUTES:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
	PROJECT_STATUS:
		'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
} as const;
